import LazyLoad from 'vanilla-lazyload/dist/lazyload.min';
const $win = $(window);

$win.on('shopify:section:select', function(){
  $('body').addClass('customize-editor');

  if ($('.lazyload').length) {
    const myLazyLoad = new LazyLoad({
      elements_selector: '.lazyload'
    });
  };
});

$win.on('load', function() {
  $('body').addClass('loaded');
});



// WEBPACK FOOTER //
// ../assets/js/global.js